import { render, staticRenderFns } from "./MicroPlayerSetup.vue?vue&type=template&id=063bc24e&"
import script from "./MicroPlayerSetup.vue?vue&type=script&lang=js&"
export * from "./MicroPlayerSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports